var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"scroll-wrap"},[_c('ul',{staticClass:"scroll-content",style:({ top: _vm.top })},_vm._l((_vm.params.list),function(item){return _c('li',{key:item.id},[_c('span',{staticClass:"el-icon-s-comment"}),_vm._v("\n          "+_vm._s(item.title)+"\n        ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }